export const reviewData = [
  {
    id: 1,
    rating: '',
    webp: '/images/riri-w.webp',
    png: '/images/riri-w.png',
    user: 'Riri Williams',
    location: 'Queens, New York',
    reviewText:
      'I am delighted with my experience. The plant arrived in excellent condition, well-packaged, and the selection on the website made it easy to find the perfect green companion for my home.',
  },
  {
    id: 2,
    rating: '',
    webp: '/images/jessica-j.webp',
    png: '/images/jessica-j.png',
    user: 'Jessica Jones',
    location: 'South Portland, Maine',
    reviewText:
      'I was impressed by the thoughtful packaging and healthy plants. Even in Maine’s colder climate, everything arrived vibrant and ready to thrive. The site made it easy to find plants suited for my space.',
  },
  {
    id: 3,
    rating: '',
    webp: '/images/ororo-m.webp',
    png: '/images/ororo-m.png',
    user: 'Ororo Munroe',
    location: 'Los Angeles, California',
    reviewText:
      'Everything from browsing to delivery was seamless. My plants were lush and full of life when they arrived. I especially loved the care instructions that came with each one — super helpful!',
  },
  {
    id: 4,
    rating: '',
    webp: '/images/wade-w.webp',
    png: '/images/wade-w.png',
    user: 'Chad Knudsen',
    location: 'Austin, Texas',
    reviewText:
      'Fantastic experience! The Plant Haus has a beautiful selection, and my order came quicker than expected. The plants are healthy, and I could tell they were packed with care for the Texas heat.',
  },
  {
    id: 5,
    rating: '',
    webp: '/images/samantha-f.webp',
    png: '/images/samantha-f.png',
    user: 'Samantha Fox',
    location: 'Brooklyn, New York',
    reviewText:
      'I absolutely love my new plants! They arrived in perfect shape and added the exact touch of green my apartment needed. The website was easy to use, and I’ll definitely be ordering again soon.',
  },
  {
    id: 6,
    rating: '',
    webp: '/images/zach-l.webp',
    png: '/images/zach-l.png',
    user: 'Zach Lai',
    location: 'Portland, Oregon',
    reviewText:
      'The quality was top-notch. My plants came looking even better than the photos online. I appreciate the eco-friendly packaging and the great customer service. Highly recommend The Plant Haus!',
  },
]
